import UserSurveyBody from "components/UserSurveyComponents/UserSurveyBody/UserSurveyBody";
import React from "react";

const UserSurvey = () => {
  return <UserSurveyBody />;
};

export default UserSurvey;
